import React from 'react'
import useSWRImmutable from 'swr/immutable'

import Loading from '../../components/layout/Loading'
import SelectInput from '../../components/form/SelectInput'
import { useI18N } from '../../../libraries/i18n/hook'
import { getAllCareerPaths } from '../../../api/career-paths'

type Props = {
  onChange: (values: { careerPathIds: string[] }) => void,
  values?: string[]
  label?: string
}
const CareerPathSelectBox: React.FC<Props> = ({ onChange, values, label }) => {
  const { t } = useI18N()
  const { data, isLoading } = useSWRImmutable('career-paths', getAllCareerPaths)

  if(isLoading) return <Loading />

  const handleChange = (ids: string[]) => {
    onChange({ careerPathIds: ids })
  }

  const options = data?.map(({ name, id }) => ({ label: name, value: id.toString() }))
  if(!options) return null
  return (
    options && (
      <SelectInput
        isDisabled={options?.length === 0}
        value={options?.filter(carreerPath => values?.includes(carreerPath.value.toString()))}
        name='careerPathIds'
        label={label ?? t('common.industry')}
        onChange={handleChange}
        options={options}
        autoMinWidth
      />
    )
  )
}

export default CareerPathSelectBox
